import Vue from 'vue';
import Vuex from 'vuex';
import { createLogger } from 'vuex';
import app from './modules/app';
import project from './modules/project';
import user from './modules/user';
import notification from './modules/notification';
import rewardPeriod from './modules/rewardPeriod';

Vue.use(Vuex);

const isDevEnv = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  strict: isDevEnv,
  plugins: isDevEnv ? [createLogger()] : [],
  modules: {
    app,
    notification,
    project,
    user,
    rewardPeriod
  }
});
